import { CompanyAiInsights } from "../Model/AiInsightObjects";

export const COMPANY_AI_INSIGHTS = "COMPANY_AI_INSIGHTS";

const initialState = new CompanyAiInsights(null, {});

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case COMPANY_AI_INSIGHTS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "companyAiInsights";

const storeMapping = {[storeName]: reducer};

export const companyAiInsightsSelector = (state) => state[storeName];

export default storeMapping; 
